import { memo } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { getAllServices } from '../../api/ListOfServicesPerCategory';
import { getAlcaldias } from '../../api/Alcaldia';
import {
    Container,
    LinkText,
    Subtitle,
    Title,
    MinDivider
} from './styles/ServiceDirectoryMenuStyles';

function ServiceDirectoryMenu() {
    const history = useHistory();

    const { data: listOfServices, isLoading } = useQuery(['listOfServices'], () => getAllServices())
    const { data: alcaldias, isLoading: alcaldiasLoading } = useQuery(['alcaldias'], () => getAlcaldias(), { staleTime: 0, cacheTime: 0 })

    if (isLoading || alcaldiasLoading) return null;
    return (
        <Container >
            <div style={{ width: '80%', alignSelf: 'center', marginTop: '30px' }}>
                <Title style={{ textTransform: 'uppercase' }}>
                    trámites
                </Title>
                <MinDivider />
                {
                    listOfServices.map((item) => (
                        <div key={item.id} style={{ marginTop: '10px', width: '100%' }}>
                            <Subtitle onClick={() => history.push(`/app/listOfServices/${item.id}`)}>{item.name}</Subtitle>
                            {
                                item.services.map((services) => (
                                    <div key={services.id} style={{ width: '100%' }}>
                                        <LinkText title={services.name}
                                            onClick={() => history.push(`/app/serviceDescription/${services.id}`)}>
                                            {services.name}
                                        </LinkText>
                                    </div>
                                ))
                            }
                        </div>
                    ))
                }

                {alcaldias && alcaldias.length > 0 && (
                    <div style={{ marginTop: '10px', width: '100%' }}>
                        <Subtitle>AYUNTAMIENTOS</Subtitle>
                        {alcaldias.map((alcaldia) => (
                            <div key={alcaldia.id} style={{ width: '100%' }}>
                                <LinkText
                                    title={alcaldia.name}
                                    onClick={() => history.push(`/app/alcaldias/${alcaldia.institution_id || alcaldia.id}`)}>
                                    {alcaldia.name}
                                </LinkText>
                            </div>
                        ))}
                    </div>
                )}

            </div>

        </Container>
    );
}

export default memo(ServiceDirectoryMenu);
